import { SettingsRounded } from '@mui/icons-material';
import { FunctionComponent, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { MainMenuButton } from './MainMenuButton';
import { useTranslation } from '@/lib';

export const ConfigurationButton: FunctionComponent = () => {
  const [activePathnames, setActivePathnames] = useState(['/app/configuration']);
  const [isRouteActive, setIsRouteActive] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const currentLocation = useLocation();
  useEffect(() => {
    if (currentLocation.pathname) {
      setIsRouteActive(activePathnames.some((r) => currentLocation.pathname.startsWith(r)));
    }
  }, [activePathnames, currentLocation.pathname]);

  function onConfigurationButtonClicked() {
    navigate({ pathname: 'configuration' });
  }

  return (
    <MainMenuButton
      isActive={isRouteActive}
      label={t('configuration')}
      icon={<SettingsRounded fontSize="inherit" />}
      onClick={onConfigurationButtonClicked}
    />
  );
};
